import { Directive, Renderer, ElementRef, Input } from '@angular/core';

@Directive({
  selector : '[AutoFocus]'
})
export class AutoFocusDirective {

  @Input() TemplateValues: any;
  
  constructor(public renderer: Renderer, public elementRef: ElementRef) {}

  ngOnInit() {
    //auto focus the added input if desired by the config.
    if(this.TemplateValues && this.TemplateValues.AutoFocus !== undefined && this.TemplateValues.AutoFocus)
      this.renderer.invokeElementMethod(this.elementRef.nativeElement, 'focus', []);
  }
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/auto-focus.directive.ts